import ConversionHistoryDetail from "@/features/dashboard/pages/conversion-history/components";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/dashboard/conversion-history/$id")(
  {
    component: () => {
      const { id } = Route.useParams();

      return (
        <main
          role="main"
          aria-label={`Conversion history details for item ${id}`}
          className="w-full"
        >
          <ConversionHistoryDetail id={id} />
        </main>
      );
    },
    errorComponent: () => (
      <div
        role="alert"
        className="flex min-h-screen items-center justify-center p-4"
      >
        <div className="text-center">
          <h1 className="text-2xl font-bold">
            Error Loading Conversion Details
          </h1>
          <pre className="mt-4">
            Please try refreshing or contact us using the chat icon on your
            screen
          </pre>
        </div>
      </div>
    ),
  }
);
